import { Header } from "../components/header/Header";

export class CommonService {
    public header: Header;

    public setHeaderRef(header) {
        this.header = header;
    }

    public setHeaderImage(url: string) {
        this.header.setHeaderImage(url);
    }

    public setFooterImage(url: string) {
        this.header.setFooterImage(url);
    }

}


// WEBPACK FOOTER //
// ./services/common.service.ts